// Grafico a ciambella distribuzione stati ticket — Recharts
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import { Card, CardHeader, CardTitle } from '../../../components/ui/Card'

interface StatusData {
  status: string
  count: number
  color: string
}

interface TicketStatusChartProps {
  data?: StatusData[]
}

const DEFAULT_DATA: StatusData[] = [
  { status: 'Nuovo', count: 0, color: 'var(--fc-status-new)' },
  { status: 'Assegnato', count: 0, color: 'var(--fc-status-assigned)' },
  { status: 'In lavorazione', count: 0, color: 'var(--fc-status-in-progress)' },
  { status: 'Completato', count: 0, color: 'var(--fc-status-completed)' },
  { status: 'Escalato', count: 0, color: 'var(--fc-status-escalated)' },
]

export function TicketStatusChart({ data = DEFAULT_DATA }: TicketStatusChartProps) {
  const total = data.reduce((sum, d) => sum + d.count, 0)

  return (
    <Card>
      <CardHeader>
        <CardTitle>Distribuzione stati</CardTitle>
        <span className="text-sm text-[var(--fc-foreground-muted)]">{total} totali</span>
      </CardHeader>
      {total === 0 ? (
        <div className="flex items-center justify-center py-10 text-sm text-[var(--fc-foreground-muted)]">
          Nessun dato disponibile
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={240}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={90}
              paddingAngle={2}
              dataKey="count"
              nameKey="status"
              aria-label="Grafico distribuzione stati ticket"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} stroke="none" />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: number, name: string) => [value, name]}
              contentStyle={{
                backgroundColor: 'var(--fc-surface)',
                border: '1px solid var(--fc-border)',
                borderRadius: 'var(--fc-radius)',
                fontSize: '12px',
              }}
            />
            <Legend
              iconType="circle"
              iconSize={8}
              formatter={(value) => (
                <span className="text-xs text-[var(--fc-foreground-muted)]">{value}</span>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </Card>
  )
}
